var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"100%","height":"100%"}},[_c('ellipse',{style:(_vm.elementStyles),attrs:{"cx":_vm.cx,"cy":_vm.cy,"rx":_vm.rx,"ry":_vm.ry,"fill":_vm.fill,"stroke":_vm.stroke,"stroke-width":_vm.strokeWidth}})])}
var staticRenderFns = []

export { render, staticRenderFns }